import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 10,
	viewBox: "0 0 18 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.40625 9.29346C0.328125 9.21533 0.289062 9.13721 0.289062 8.98096C0.289062 8.86377 0.328125 8.74658 0.40625 8.66846L8.6875 0.387207C8.76562 0.309082 8.84375 0.27002 9 0.27002C9.11719 0.27002 9.23438 0.309082 9.3125 0.387207L17.5938 8.66846C17.6719 8.74658 17.7109 8.86377 17.7109 8.98096C17.7109 9.13721 17.6719 9.21533 17.5938 9.29346L17.2812 9.60596C17.2031 9.68408 17.0859 9.72314 16.9688 9.72314C16.8125 9.72314 16.6953 9.68408 16.6172 9.60596L9 1.94971L1.38281 9.60596C1.26562 9.68408 1.14844 9.72314 1.03125 9.72314C0.875 9.72314 0.796875 9.68408 0.71875 9.60596L0.40625 9.29346Z",
		fill: "currentColor"
	})
});
export default SvgChevronUp;
